"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const BaseQuota_1 = __importDefault(require("./BaseQuota"));
const generateDocumentId_1 = require("../utils/generateDocumentId");
class NewPageTypesAuditsQuota extends BaseQuota_1.default {
    constructor(statsCollection, quotasFactory) {
        super(statsCollection);
        this.quotasFactory = quotasFactory;
    }
    reclaim(quotas, job) {
        return __awaiter(this, void 0, void 0, function* () {
            const blueprintJob = Object.assign({}, job);
            blueprintJob.id = (0, generateDocumentId_1.generateDocumentId)();
            blueprintJob.type = {
                component: 'audit_blueprints',
                action: 'reclaim'
            };
            blueprintJob.quantity = 1;
            blueprintJob.status = 'success';
            yield this.quotasFactory.getQuota('audit_blueprints', 'make_new')().reclaim(quotas, blueprintJob);
            yield this.quotasFactory.getQuota('page_types_audits', 'run')().reclaim(quotas, job);
            return job;
        });
    }
    calc(quotas, job) {
        return __awaiter(this, void 0, void 0, function* () {
            const blueprintJob = Object.assign({}, job);
            blueprintJob.id = (0, generateDocumentId_1.generateDocumentId)();
            blueprintJob.type = {
                component: 'audit_blueprints',
                action: 'make_new'
            };
            blueprintJob.quantity = 1;
            const verifiedBlueprintJob = yield this.quotasFactory.getQuota('audit_blueprints', 'make_new')().calc(quotas, blueprintJob);
            //Let's terminate the process if blueprint job is rejected
            if (verifiedBlueprintJob.status === 'rejected') {
                job.status = verifiedBlueprintJob.status;
                job.statusReason = blueprintJob.statusReason;
                return job;
            }
            /*
            const verifiedJob = await this.quotasFactory.getQuota('page_types_audits', 'run')().calc(quotas, job);
    
            //Let's return the blueprint;
            if (verifiedJob.status == 'rejected') {
                await this.quotasFactory.getQuota('audit_blueprints', 'make_new')().reclaim(quotas, blueprintJob);
                verifiedBlueprintJob.status = verifiedJob.status;
                verifiedBlueprintJob.statusReason = verifiedJob.statusReason;
            }*/
            job.status = 'allowed';
            return job;
        });
    }
}
exports.default = NewPageTypesAuditsQuota;
